import React, { useEffect, useState } from "react";
import axios from "axios";
import { adminPermission } from "../../apis/urls";
import { Loader } from "rsuite";
import { Switch, message } from "antd";

const PERMISSION_LABELS = [
    { key: "dashboard", label: "Dashboard" },
    { key: "admin", label: "Admin" },
    { key: "schools", label: "Schools" },
    { key: "officials", label: "Officials" },
    { key: "rules", label: "Rules" },
    { key: "seminar", label: "Seminar" },
    { key: "conference_manager", label: "Conference Manager" },
    { key: "exhibitor", label: "Exhibitor" },
    { key: "master", label: "Master" }
];

const Listadmin = () => {
    useEffect(() => {
        document.body.classList.remove('new-login-wrpr');
        setLoader(true);
        const token = "Bearer " + localStorage.getItem('token');
        const instance = axios.create({
            baseURL: adminPermission + "/list",
            timeout: 1000000,
            headers: { 'authorization': token }
        });
        instance.get("").then((response) => {
            setResult(response.data.users || []);
            setLoader(false);
        }).catch((error) => {
            setLoader(false);
        });
    }, []);

    const [loader, setLoader] = useState(false);
    const [result, setResult] = useState([]);
    const loggedInUserId = localStorage.getItem('userid');

    // Toggle handler with API call (send { userId, [permission]: value })
    const handleToggle = (userId, permKey, checked) => {
        setResult(prev => prev.map(user => {
            if (user.id === userId) {
                let perms = user.adminpermissions && user.adminpermissions.length > 0 ? { ...user.adminpermissions[0] } : {};
                perms[permKey] = checked ? 1 : 0;
                return {
                    ...user,
                    adminpermissions: user.adminpermissions && user.adminpermissions.length > 0 ? [perms] : [perms]
                };
            }
            return user;
        }));
        // API call to update permission in requested format
        const token = "Bearer " + localStorage.getItem('token');
        const data = {
            userId,
            [permKey]: checked ? 1 : 0
        };
        axios.post(adminPermission + "/create", data, {
            headers: { 'authorization': token }
        })
        .then(() => {
            message.success("Permission updated successfully");
        })
        .catch(() => {
            message.error("Failed to update permission");
        });
    };

    return (
        <div>
            <aside className="right-side areas">
                <div className="content-area dash-contentss">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            <h2 className="page-title">Admin Users & Permissions</h2>
                        </div>
                    </div>
                    <div className="containers" style={{ overflow: 'auto' }}>
                        {loader ? (
                            <div className="loader_container"><Loader /></div>
                        ) : null}
                        {result && result.length > 0 ? (
                            <table className="table table-rules">
                                <thead>
                                    <tr className="rules-table-head">
                                        <th scope="col">Sl.No</th>
                                        <th scope="col">Username</th>
                                        {PERMISSION_LABELS.map(perm => (
                                            <th key={perm.key} scope="col">{perm.label}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="rules-table-content">
                                    {result.map((user, index) => {
                                        const perms = user.adminpermissions && user.adminpermissions.length > 0 ? user.adminpermissions[0] : {};
                                        const isCurrentUser = String(user.id) === String(loggedInUserId);
                                        return (
                                            <tr key={user.id} style={isCurrentUser ? { background: '#f5f5f5' } : {}}>
                                                <td>{index + 1}</td>
                                                <td>{user.username}</td>
                                                {PERMISSION_LABELS.map(perm => (
                                                    <td key={perm.key}>
                                                        <Switch
                                                            checked={perms[perm.key] === 1}
                                                            onChange={checked => handleToggle(user.id, perm.key, checked)}
                                                            disabled={isCurrentUser}
                                                        />
                                                    </td>
                                                ))}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        ) : (
                            <div className="nodata" style={{ marginTop: '100px' }}>
                                <h2>Sorry! No Admin Users Found</h2>
                            </div>
                        )}
                    </div>
                </div>
            </aside>
        </div>
    );
}

export default Listadmin;